import { createNamespacedHelpers } from 'vuex';
const globalMapper = createNamespacedHelpers('global');
const modelMapper = createNamespacedHelpers('detector/model');

import showToast from '@/util/toast';
import { HttpStatusCode } from 'axios';

export default {
	name: 'ModalPromptSuggestion',

	props: {
		modalId: {
			type: String,
		},
		selectedModel: {
			type: Object,
			default: {}
		},
		getPredictionImage: {
			type: Function
		}
	},

	data() {
		return {
			slide: 0,
			searchedModel: '',
			dropdownOpen: false,
			dropdownUserOpen: false,

			allowShareData: false,
			appMode: process.env.VUE_APP_MODE,
		};
	},

	methods: {
		...globalMapper.mapActions(['setSpinner']),
		...modelMapper.mapActions(['suggestPrompt']),
		onCloseModal() {
			this.dropdownOpen = false;
			this.$bvModal.hide(this.modalId);
		},


		onClickOutSide() {
			this.dropdownUserOpen = false;
		},

		isModelWaiting(status) {
			return status === 'waiting';
		},


		shown() {
			this.$store.dispatch('detector/showFormModal', true);
		},

		hidden() {
			this.onCloseModal();
			this.$store.dispatch('detector/showFormModal', false);
		},

		async onSettingPrompSuggestion() {
			// Update quantity from given data
			this.setSpinner(true);	
			let image = await this.getPredictionImage()

			let data = {
				"modelId": this.selectedModel._id.$oid,
				"gt_cnt": this.selectedModel.options.gt_cnt,
				"image" : image
			}
			let response = await this.suggestPrompt(data);
			if (response.status != HttpStatusCode.Ok) {
				showToast({
					vueInstance: this,
					type: 'error',
					message: this.$t('fail'),
				});
    
        return;
			}
			showToast({
				vueInstance: this,
				type: 'success',
				message: this.$t('success'),
			});

			this.selectedModel.options.TEXT_PROMPT = response.data?.best_prompt
			this.setSpinner(false);
		},

	},
};
